import vtRequestId from './vt-request-id';

const buildApiUrl = (path, host = process.env.NEXT_PUBLIC_VT_API_ENDPOINT) => `${host}${path}`;

export class ApiFetchError extends Error {
  constructor(message: string, public path: string, public response: Response) {
    super(message);
  }
}

const safeGetJson = async (res: Response) => res.json().catch(() => null);

interface ApiFetchOptions extends RequestInit {
  host?: string;
}

/**
 * A generic Fetcher for use with SWR that adapts to our API service.
 **/
export default function apiFetch<T = any>(path: string, { host, ...init }: ApiFetchOptions = {}) {
  return fetch(buildApiUrl(path, host), {
    ...init,
    credentials: 'include',
    mode: 'cors',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      'x-vt-requestid': vtRequestId(),
      ...(init.headers || {}),
    },
  }).then(async (res) => {
    const json = await safeGetJson(res);
    if (res.ok) return json as T;
    throw new ApiFetchError(json?.error || 'Error fetching data', path, res);
  });
}
